//GeneratorFlag:[NoChange]
import ProductGroup from './product-group';
import ProductGroupFilter from './product-group-filter';

export default {ProductGroup, ProductGroupFilter}
export{ProductGroup, ProductGroupFilter}